<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">© MAXAPI All Right Reserved.</div>
        <div class="col-sm-6">
          <!-- <div class="text-sm-end d-none d-sm-block">Design & Developed by Henry</div> //-->
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
